module.exports = __webpack_public_path__ + "static/card-secretary-frank-colonna-8bf5069529f727fbd3b9a352c784771d.jpg";